/**
 * What a position text comes to when the PDF prints it.
 *
 * The print takes the short description where there is one and the long one
 * otherwise, strips the formatting and then cuts at the last whole word before
 * the limit. The mask counts the same way, so that what it says matches what
 * comes out of the printer (FRM-Z, #2225).
 */

/** The text as the print sees it: no markup, no markdown marks, one line. */
export const paloPlainText = (text?: string | null): string =>
    (text ?? '')
        // Tags first: the editor writes markdown, but pasted text brings HTML.
        .replace(/<[^>]*>/g, ' ')
        // The marks around a word are not printed, the word is.
        .replace(/[*_`~#>]/g, '')
        .replace(/!?\[([^\]]*)\]\([^)]*\)/g, '$1')
        .replace(/\s+/g, ' ')
        .trim();

/** Which of the two texts the print uses, and how long it is. */
export const paloPrintedPosition = (
    shortDescription?: string | null,
    longDescription?: string | null
): { text: string; isShort: boolean; length: number } => {
    const short = paloPlainText(shortDescription);
    const text = short || paloPlainText(longDescription);

    return { text, isShort: '' !== short, length: text.length };
};
